export const REGEX_PATTERNS = {
    // EMAIL_PATTERN: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    // EMAIL_PATTERN: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
    EMAIL_PATTERN: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    MOBILE_PATTERN: /^(\d{10}|\w+@\w+\.\w{2,3})$/,
    MOBILE_PATTERN_2: /(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})$/,
    USA_MOBILE : /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
    // NAME_PATTERN: /([a-zA-Z][0-9!@#$&()\\-`.+,/\"])*$/, <------------------1
    // NAME_PATTERN: /^(?![_.0-9@#$&()\\-`.+,/\"])[a-zA-Z0-9._ -]+(?<![_.-])$/,<------2
    NAME_PATTERN: /^[a-zA-Z ]([: _]?[0-9A-Za-z ])*\/?$/,
    BUISNESS_NAME_PATTERN: /^(?![0-9/ ]+$)[a-zA-Z0-9 ]([: _]?[0-9A-Za-z ])*\/?$/,
    PASSWORD_PATTERN: /^[^\s]+(\s+[^\s]+)*$/,
    WHITE_SPACE_PATTERN: /\s/g,
    MOBILE_CLEAN: /[!@#$%^&*/\s-]/g,
    SLASH_PATTERN: /[/]/g,
    GST_PATTERN: /^[A-Z0-9]*$/,
    AADHAR_PATTERN: /^[0-9]*$/,
    INTEGER_PATTERN: /^-?(0|[1-9]\d*)?$/,
    NUMBER_REMOVE: /[a-zA-Z!`@#$%^&*,.?":{}()\]|<\[>~_=';"-/\\ \n\r]/g,
    NUMBER_REMOVE_DE: /[a-zA-Z!`@#$%^&*,?":{}()\]|<\[>~_=';"-/\\ \n\r]/g,
    NUMBER_REMOVE_DATE : /[a-zA-Z!`@#$%^&*,.?":{}()\]|<\[>~_=';"-.\\ \n\r]/g,
    TITLE_PATTERN: /^(?=.*?[a-zA-Z]).+$/,
    TEXT_AREA: /^(?=.*?[a-zA-Z]).+(\n?.*)*/,
    IBAN: /^[A-Z]{2}\d{2} (?:\d{4} ){3}\d{4}(?: \d\d?)?$/,
    SORT_CODE: /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/,
    SWIFT_CODE: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/
}